import React from "react";
import {Link} from "react-router-dom";
import {Alert, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {canViewTenantUsers, useUser} from "../providers/user-context";
import {courierName} from "../data-tables-distributor/orders/courier-api";
import {availabilityLabel} from "./courier-profile-form";
import useCourierData from "./use-courier-data";
import CourierOrders from "./courier-orders";
import {Refresh as RefreshIcon} from "@mui/icons-material";

export default function CourierDetailsDialog({id, onClose}) {
    const {t} = useTranslation();
    const {tenantId, tenantType, userRole} = useUser();
    const {data: profile, loading, refreshing, error, refresh, version} = useCourierData(tenantId, id);
    return <Dialog open fullWidth maxWidth="lg" onClose={onClose}>
        <DialogTitle>{t("CourierProfile")}</DialogTitle>
        <DialogContent>
            {loading ? <CircularProgress aria-label={t("LoadingCouriers")}/> : error ? <Alert severity="error"
                action={<Button color="inherit" onClick={refresh}>{t("Retry")}</Button>}>{t(error)}</Alert> : <>
                <Typography variant="h6">{courierName(profile)}</Typography>
                <Typography sx={{mb: 2}}>{profile.userEmail}</Typography>
                <Stack direction="row" spacing={1} sx={{mb: 2}}><Chip label={t(availabilityLabel(profile.availability))}/>
                    <Chip label={t(profile.active ? "Active" : "Inactive")}/></Stack>
                <Typography>{t("CourierActiveOrders")}: {profile.activeOrderCount} / {profile.maxActiveOrders}</Typography>
                <Typography>{t("CourierRemainingCapacity")}: {profile.remainingCapacity}</Typography>
                {refreshing && <CircularProgress size={20} aria-label={t("LoadingCouriers")}/>}
                <CourierOrders id={id} version={version} onRefresh={refresh} refreshDisabled={refreshing}/>
            </>}
        </DialogContent>
        <DialogActions><Button disabled={loading || refreshing} startIcon={<RefreshIcon/>} onClick={refresh}>{t("Refresh")}</Button>
            {profile && !error && canViewTenantUsers(tenantType, userRole) &&
                <Button component={Link} to={`/distributor/users/couriers/${id}`}>{t("ViewCourierProfile")}</Button>}
            <Button onClick={onClose}>{t("Close")}</Button></DialogActions>
    </Dialog>;
}
